module.exports = __webpack_public_path__ + "img/airplane.fe7ad351.png";